document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const liveConfigElement = document.querySelector('[data-live-config]');
  let liveConfig = {
    status: 'scheduled',
    nextDate: 'PROGRAMMA IN ARRIVO',
    pauseMessage: 'Le aperture in live sono temporaneamente sospese. Puoi continuare ad acquistare tutti i prodotti con spedizione sigillata.',
    tiktokUrl: '',
    instagramUrl: ''
  };
  if (liveConfigElement) {
    try { liveConfig = { ...liveConfig, ...JSON.parse(liveConfigElement.textContent) }; } catch (error) { /* Keep safe defaults. */ }
  }

  document.querySelectorAll('[data-social-link="tiktok"]').forEach((link) => {
    if (liveConfig.tiktokUrl) link.href = liveConfig.tiktokUrl;
    else link.setAttribute('aria-disabled', 'true');
  });
  document.querySelectorAll('[data-social-link="instagram"]').forEach((link) => {
    if (liveConfig.instagramUrl) link.href = liveConfig.instagramUrl;
    else link.setAttribute('aria-disabled', 'true');
  });

  const livePaused = liveConfig.status === 'paused';
  document.querySelectorAll('[data-live-page]').forEach((page) => {
    const status = page.querySelector('[data-live-status-label]');
    const date = page.querySelector('[data-live-next-date]');
    const message = page.querySelector('[data-live-page-message]');
    const booking = page.querySelector('[data-live-booking-link]');
    if (livePaused) {
      if (status) status.textContent = 'LIVE TEMPORANEAMENTE IN PAUSA';
      if (date) date.textContent = 'TORNIAMO PRESTO';
      if (message) message.textContent = liveConfig.pauseMessage;
      if (booking) {
        booking.textContent = 'APERTURE LIVE IN PAUSA';
        booking.removeAttribute('href');
        booking.setAttribute('aria-disabled', 'true');
      }
    } else {
      if (status) status.textContent = liveConfig.status === 'available' ? 'APERTURE LIVE DISPONIBILI' : 'PROSSIMA LIVE';
      if (date) date.textContent = liveConfig.nextDate || 'PROGRAMMA IN ARRIVO';
      if (message) message.textContent = liveConfig.status === 'available' ? 'Le aperture in live sono disponibili sui prodotti abilitati.' : 'Ordina ora: ti confermeremo la data via email.';
    }
  });

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const open = document.body.classList.toggle('menu-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => document.body.classList.remove('menu-open')));

  document.querySelectorAll('[data-hero]').forEach((hero) => {
    let state = 0;
    const mobile = matchMedia('(max-width: 749px)').matches;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const setState = (next) => {
      state = Math.max(0, Math.min(3, next));
      hero.dataset.state = String(state);
      hero.querySelectorAll('[data-step]').forEach((el, i) => el.classList.toggle('is-active', i <= state));
    };
    if (!mobile || reducedMotion) {
      hero.querySelector('[data-hero-trigger]')?.addEventListener('click', () => setState((state + 1) % 4));
    }
    if (mobile && !reducedMotion) {
      hero.querySelector('[data-hero-trigger]')?.setAttribute('tabindex', '-1');
      const update = () => {
        const rect = hero.getBoundingClientRect();
        const p = Math.max(0, Math.min(0.999, -rect.top / Math.max(1, hero.offsetHeight - innerHeight)));
        setState(Math.floor(p * 4));
      };
      addEventListener('scroll', update, { passive: true }); update();
    }
  });

  document.querySelectorAll('[data-universe]').forEach((wrap) => {
    const cards = [...wrap.querySelectorAll('[data-universe-card]')];
    const rail = wrap.querySelector('[data-universe-rail]');
    if (!rail || !cards.length) return;

    // A second, hidden-on-desktop set makes the mobile movement continuous.
    // The original cards remain untouched, so desktop layout and hover stay identical.
    cards.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.classList.add('universe-card--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      rail.appendChild(clone);
    });

    const interactiveCards = [...rail.querySelectorAll('[data-universe-card]')];
    let startX = 0;
    let startScroll = 0;
    let dragged = false;
    let pointerActive = false;
    let resumeAutoplayAt = 0;
    const mobileRail = matchMedia('(max-width: 749px)').matches;

    rail?.addEventListener('pointerdown', (event) => {
      if (!mobileRail || event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerActive = true;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
      dragged = false;
      resumeAutoplayAt = Number.POSITIVE_INFINITY;
    });
    rail?.addEventListener('pointermove', (event) => {
      if (!mobileRail || !pointerActive || event.pointerType !== 'mouse') return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 6 && !dragged) {
        dragged = true;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(event.pointerId);
      }
      if (!dragged) return;
      rail.scrollLeft = startScroll - distance;
      event.preventDefault();
    });
    const endDrag = (event) => {
      if (!mobileRail || event.pointerType !== 'mouse') return;
      pointerActive = false;
      if (rail?.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
      rail?.classList.remove('is-dragging');
      resumeAutoplayAt = performance.now() + 1800;
    };
    rail?.addEventListener('pointerup', endDrag);
    rail?.addEventListener('pointercancel', endDrag);

    // Touch uses the browser's native horizontal swipe. Autoplay pauses briefly
    // while the customer interacts, then resumes from the new position.
    rail?.addEventListener('touchstart', () => {
      resumeAutoplayAt = Number.POSITIVE_INFINITY;
    }, { passive: true });
    rail?.addEventListener('touchend', () => {
      resumeAutoplayAt = performance.now() + 1800;
    }, { passive: true });
    rail?.addEventListener('touchcancel', () => {
      resumeAutoplayAt = performance.now() + 1800;
    }, { passive: true });

    // Desktop highlighting is handled only by CSS :hover so the card under
    // the cursor is the sole active card and nothing can start cycling.
    interactiveCards.forEach((card) => card.addEventListener('click', (event) => {
      if (dragged) { event.preventDefault(); return; }
    }));

    if (rail && mobileRail && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let previousTime = performance.now();
      resumeAutoplayAt = previousTime + 700;
      const autoplay = (time) => {
        const elapsed = Math.min(40, time - previousTime);
        previousTime = time;
        if (time >= resumeAutoplayAt && !rail.classList.contains('is-dragging')) {
          const firstOriginal = cards[0];
          const firstClone = rail.querySelector('.universe-card--clone');
          const loopWidth = firstClone ? firstClone.offsetLeft - firstOriginal.offsetLeft : 0;
          if (loopWidth > 1) {
            if (rail.scrollLeft >= loopWidth) rail.scrollLeft -= loopWidth;
            rail.scrollLeft += elapsed * 0.045;
          }
        }
        requestAnimationFrame(autoplay);
      };
      requestAnimationFrame(autoplay);
    }
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const json = form.querySelector('[data-product-json]');
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const select = form.querySelector('[name="id"]');
    const price = form.querySelector('[data-price]');
    const button = form.querySelector('[type="submit"]');
    const image = document.querySelector('[data-product-main-image]');
    const liveOption = form.querySelector('[data-live-mode-option]');
    const liveInput = liveOption?.querySelector('input');
    const sealedInput = form.querySelector('[name="properties[Modalità]"][value="Spedizione sigillata"]');
    const liveAvailability = form.querySelector('[data-live-availability]');
    const liveConsent = form.querySelector('[data-live-consent]');
    const consentInput = liveConsent?.querySelector('input');

    if (liveOption && livePaused) {
      liveOption.hidden = true;
      if (liveInput) liveInput.disabled = true;
      if (sealedInput) sealedInput.checked = true;
      if (liveAvailability) liveAvailability.textContent = liveConfig.pauseMessage;
    } else if (liveOption) {
      liveOption.hidden = false;
      if (liveInput) liveInput.disabled = false;
      if (liveAvailability && liveConfig.status === 'scheduled' && liveConfig.nextDate) {
        liveAvailability.textContent = `Prossima live: ${liveConfig.nextDate}. Dopo la diretta spediamo tutte le tue carte.`;
      }
    }

    form.querySelectorAll('[name="properties[Modalità]"]').forEach((input) => input.addEventListener('change', () => {
      const liveSelected = form.querySelector('[name="properties[Modalità]"]:checked')?.value === 'Apri in live';
      if (liveConsent) liveConsent.hidden = !liveSelected;
      if (!liveSelected && consentInput) consentInput.checked = false;
    }));
    select?.addEventListener('change', () => {
      const variant = product.variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      price.textContent = Shopify.formatMoney ? Shopify.formatMoney(variant.price) : `${(variant.price / 100).toFixed(2)} €`;
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'AGGIUNGI AL CARRELLO' : 'ESAURITO';
      const selectedOption = select.options[select.selectedIndex];
      const variantImage = variant.featured_image?.src || selectedOption?.dataset.image;
      if (variantImage && image) { image.src = variantImage; image.removeAttribute('srcset'); image.alt = variant.featured_image?.alt || variant.name; }
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    });
    const queryVariant = new URLSearchParams(window.location.search).get('variant');
    if (queryVariant && [...select.options].some(option => option.value === queryVariant)) {
      select.value = queryVariant;
      select.dispatchEvent(new Event('change'));
    }
    form.addEventListener('submit', (event) => {
      const live = form.querySelector('[name="properties[Modalità]"]:checked')?.value === 'Apri in live';
      const consent = form.querySelector('[name="properties[Conferma apertura live]"]');
      if (live && consent && !consent.checked) { event.preventDefault(); alert('Conferma l’apertura in live prima di continuare.'); }
    });
  });

  document.querySelectorAll('[data-accordion]').forEach((button) => button.addEventListener('click', () => {
    const item = button.closest('.accordion');
    const open = item.classList.toggle('is-open');
    button.setAttribute('aria-expanded', String(open));
  }));
});
